import React from "react";
import * as S from "./styles";
import { moneyMask, convertISODateMode3 } from "~/utils/mask";

const InfoBoxesRow = ({ data }) => {
    return (
        <S.InfoBoxesRow>
            <S.InfoBox>
                <S.BoxLabel>
                    Vencimento
                </S.BoxLabel>
                <S.BoxValueSmall>
                    {convertISODateMode3(data?.dataVencimento)}
                </S.BoxValueSmall>
            </S.InfoBox>

            <S.InfoBox>
                <S.BoxLabel>
                    Valor atual
                </S.BoxLabel>
                <S.BoxValueSmall>
                    {moneyMask(data?.saldoFaturaAtual)}
                </S.BoxValueSmall>
            </S.InfoBox>

            <S.InfoBox>
                <S.BoxLabel>
                    Valor mínimo
                </S.BoxLabel>
                <S.BoxValueSmall>
                    {moneyMask(data?.valorMinimoRecebido)}
                </S.BoxValueSmall>
            </S.InfoBox>
        </S.InfoBoxesRow>
    );
};

export default InfoBoxesRow;